import styled, { keyframes } from "styled-components";
import { COLORS } from "@/react/theme/constants";

const pulse = keyframes`
    0% {
        opacity: 0.3;
    }
    50% {
        opacity: 0.8;
    }
    100% {
        opacity: 0.3;
    }
`;

const SkeletonText = styled.div`
  background-color: ${COLORS.tertiary};
  height: 16px;
  margin-bottom: 8px;
  border-radius: 4px;
  animation: ${pulse} 1.5s infinite linear;
  width: ${({ subtractWidth }) =>
    `calc(100% - 32px - ${subtractWidth || 0}px)`};
  max-width: 100%;
`;

const MIN_WIDTH_DIFFERENCE = 50;
const MAX_WIDTH_DIFFERENCE = 300;

/**
 * Render skeleton lines with random width difference
 * For a pleasing appearance, all the other lines except the first one
 * will have a randomly picked width difference from 50px to 300px
 */
const Skeleton = ({ rows }) => (
  <>
    {Array.from({ length: rows }, (_, i) => (
      <SkeletonText
        key={i}
        subtractWidth={
          i === 0
            ? 0
            : Math.floor(
                Math.random() * (MAX_WIDTH_DIFFERENCE - MIN_WIDTH_DIFFERENCE)
              ) + MIN_WIDTH_DIFFERENCE
        }
      />
    ))}
  </>
);

export default Skeleton;
